/**
 * Chat Widget Overlap Prevention for Ritual Selector Section
 * DISABLED: Luna chatbot now stays visible on shop ritual page
 * Previously hid chat widget launcher when ritual selector section was in viewport
 * 
 * Keeping file for reference but functionality is disabled
 */

(function() {
  'use strict';
  
  // DISABLED: Luna should remain visible on shop ritual page
  // If overlap becomes an issue, adjust positioning via CSS instead
  
  // Also ensure any existing hide class is removed
  function ensureLunaVisible() {
    const chatButton = document.getElementById('luna-chatbot-button');
    if (chatButton) {
      chatButton.classList.remove('veluna-ritual-selector-hide-chat');
      console.log('[LUNA] Ensuring chatbot is visible');
    }
  }
  
  // Remove hide class immediately and on DOM ready
  ensureLunaVisible();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureLunaVisible);
  }
  
  // Keep checking and removing the class
  setInterval(ensureLunaVisible, 1000);
  
  return;
  
  // Legacy code below (not executed)
  const selector = document.querySelector('.veluna-ritual-primary-selector');
  if (!selector) {
    return;
  }
  
  const isCollectionPage = document.body.classList.contains('template-collection') || 
                           window.location.pathname.includes('/collections/');
  
  if (!isCollectionPage) {
    return;
  }
  
  if (!('IntersectionObserver' in window)) {
    return;
  }
  
  const chatButton = document.getElementById('luna-chatbot-button');
  
  if (!selector || !chatButton) {
    return;
  }
  
  const HIDE_CLASS = 'veluna-ritual-selector-hide-chat';
  let isHidden = false;
  
  const observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        const shouldHide = entry.isIntersecting;
        
        if (shouldHide !== isHidden) {
          isHidden = shouldHide;
          
          if (isHidden) {
            chatButton.classList.add(HIDE_CLASS);
          } else {
            chatButton.classList.remove(HIDE_CLASS);
          }
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -20% 0px',
      threshold: [0, 0.1, 0.25]
    }
  );
  
  observer.observe(selector);
  
  window.addEventListener('beforeunload', function() {
    observer.disconnect();
  });
})();

